import script from "./AdminMemberDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminMemberDetail.vue?vue&type=script&setup=true&lang=js"

import "./AdminMemberDetail.vue?vue&type=style&index=0&id=f9b76f02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9b76f02"]])

export default __exports__